import { useMutation } from '@apollo/client';

import { InvoiceStatus } from '__generated__/GQL';

import { MarkInvoiceAsPaidDocument } from './graphql/markInvoiceAsPaid.gql';

interface UseMarkInvoiceAsPaidParams {
  clientId: string;
  companyProfileId: string;
  invoiceId: string;
  status: InvoiceStatus;
}

export const useMarkInvoiceAsPaid = ({
  invoiceId,
}: UseMarkInvoiceAsPaidParams) =>
  useMutation(MarkInvoiceAsPaidDocument, {
    awaitRefetchQueries: true,
    variables: { input: { invoiceId } },
  });
